import { Box, Skeleton } from '@mui/material';

export const AuthFormPresentationSkeleton: React.FC = () => {
  return (
    <Box className="container-fluid-left">
      <Box sx={{ height: '100%', py: 7.5 }}>
        <Skeleton height="4.5rem" width="10rem" />
        <Skeleton height="20rem" width="60%" sx={{ my: 7.5 }} variant="rectangular" />
        <Skeleton height="1rem" width="8rem" variant="text" />
      </Box>
    </Box>
  );
};
